



















import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwApp } from '@sonicwall/unified-ui-framework/src/shared/sw-app';
import { SwAppMain } from '../sw-app-main';

@Component({
  components: {
    SwBlockingProgress,
    SwApp,
    SwAppMain,
  },
})
export default class MswAppMain extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;
  showWorkspace : boolean = false;
  created() {
    console.warn(window.location);
    if (window.location.pathname.indexOf('unified-insights') > -1) {
      this.showWorkspace = false;
    } else {
      this.showWorkspace = true;
    }
  }
}
